import React, { PropsWithChildren } from 'react';

import {
  useAddBusinessPlan,
  useRevampedCheckoutFlowVariant,
} from '@editor/global/growthbookUtils';
import { isMobileOperatingSystem as getIsMobileOperatingSystem } from '@repo/detection';
import { Modal } from '@repo/ui/deprecated/Modal';
import { Dialog } from '@repo/ui-kit/components/core/Dialog';

import useWindowSize from '../../hooks/useWindowSize';

import { ModalWrapperProps } from './types';

const ModalWrapper: React.FC<PropsWithChildren<ModalWrapperProps>> = ({
  isOpen,
  onClose,
  children,
  width,
  height,
  ...rest
}) => {
  const { isMobile } = useWindowSize();
  const isMobileOperatingSystem = getIsMobileOperatingSystem();

  const showRevampedCheckoutFlow = useRevampedCheckoutFlowVariant() !== 'off';
  const businessPlanIsEnabled = useAddBusinessPlan();

  const desktopModalHeight = showRevampedCheckoutFlow ? '720px' : '640px';
  const desktopModalWidth = businessPlanIsEnabled ? '988px' : '940px';

  if (showRevampedCheckoutFlow) {
    return (
      <Dialog.Root
        modal
        open={isOpen}
        onOpenChange={(open) => {
          if (!open) {
            onClose?.();
          }
        }}
      >
        <Dialog.Content
          global
          height={
            isMobileOperatingSystem ? '100vh' : (height ?? desktopModalHeight)
          }
          showCloseButton={!isMobileOperatingSystem}
          title="Subscription Modal"
          width={
            isMobileOperatingSystem ? '100%' : (width ?? desktopModalWidth)
          }
        >
          {children}
        </Dialog.Content>
      </Dialog.Root>
    );
  }
  return (
    <Modal
      externalCloseButton={!isMobile}
      height={isMobile ? '100vh' : (height ?? desktopModalHeight)}
      isOpen={isOpen}
      noBorderRadius={isMobile}
      theme={{ padding: isMobile ? '0px' : 'unset' }}
      width={isMobile ? '100%' : (width ?? desktopModalWidth)}
      onClose={onClose}
      {...rest}
    >
      {children}
    </Modal>
  );
};

export default ModalWrapper;
